/** @type {import('../schema').ProcessDefinition} */
const saasLeads = {
  id: "saas-leads",
  name: "Canal comercial: demo → lead → conversión + Partners",
  category: "saas",
  outcome:
    "Captar prospectos con acceso demo, gestionarlos como leads y convertirlos en clientes; administrar partners.",
  trigger: "Un visitante completa /solicitar-demo.",
  actors: ["Visitante", "Sistema", "Super Admin"],
  status: "COMPLETO",
  description:
    "Embudo comercial SaaS: el visitante pide una demo, el sistema crea el lead y un acceso demo de solo lectura, el comercial gestiona el CRM y el Super Admin convierte el lead en cliente real. Incluye alta de partners y co-branding.",
  lanes: [
    { id: "visit", actor: "Visitante" },
    { id: "sys", actor: "Sistema" },
    { id: "sa", actor: "Super Admin" },
  ],
  steps: [
    { id: "s1", laneId: "visit", type: "start", label: "Solicita una demo", description: "Completa nombre, email, rol, teléfono y consentimiento en /solicitar-demo.", evidence: "src/screens/SolicitarDemo.jsx" },
    { id: "s2", laneId: "sys", type: "decision", label: "¿El email ya existe?" },
    { id: "s3", laneId: "sys", type: "task", label: "Crea lead + acceso demo", description: "Crea el documento en leads y un token con claim de demo (acceso de solo lectura al edificio demo).", evidence: "src/utils/demoMode.js" },
    { id: "s4", laneId: "visit", type: "task", label: "Usa el modo demo", description: "Navega el edificio demo; las reglas bloquean escrituras y un banner avisa." },
    { id: "s5", laneId: "sa", type: "task", label: "Gestiona el CRM del lead", description: "Cambia el estado del lead (new → contacted → demo_in_progress), asigna comercial y deja notas.", evidence: "src/screens/admin/Leads.jsx" },
    { id: "s6", laneId: "sa", type: "decision", label: "¿El lead se convierte?" },
    { id: "s7", laneId: "sa", type: "task", label: "Convierte a cliente real", description: "Crea el edificio real, ajusta el rol, quita el claim demo y asigna el edificio (lead → won)." },
    { id: "s8", laneId: "sa", type: "task", label: "Alta y asignación de partner", description: "Da de alta el partner, le asigna edificios y configura co-branding en mensajes.", evidence: "src/screens/admin/Partners.jsx" },
    { id: "s9", laneId: "sa", type: "end", label: "Cliente / partner operativo", description: "El prospecto queda como cliente real (sin claim demo) o lead perdido (lost)." },
  ],
  transitions: [
    { from: "s1", to: "s2" },
    { from: "s2", to: "s3", label: "no existe" },
    { from: "s2", to: "s9", label: "existe → login" },
    { from: "s3", to: "s4" },
    { from: "s4", to: "s5" },
    { from: "s5", to: "s6" },
    { from: "s6", to: "s7", label: "sí (won)" },
    { from: "s6", to: "s9", label: "no (lost)" },
    { from: "s7", to: "s8" },
    { from: "s8", to: "s9" },
  ],
};

export default saasLeads;
